module.exports = __webpack_public_path__ + "static/media/16UNODC22.7c58c7c0.jpg";